(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lh-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.lhReady) return;
      root.dataset.lhReady = 'true';
      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsWrap = root.parentElement.querySelector('[data-dots]');
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;
      function stepSize() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function pageCount() {
        var perView = Math.max(1, Math.round(track.clientWidth / stepSize()));
        return Math.max(1, cards.length - perView + 1);
      }
      function current() { return Math.round(track.scrollLeft / stepSize()); }
      function buildDots() {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pageCount(); i++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lh-test__dot';
            b.setAttribute('aria-label', 'Go to review ' + (idx + 1));
            b.addEventListener('click', function () { track.scrollTo({ left: idx * stepSize() }); });
            dotsWrap.appendChild(b);
          })(i);
        }
        update();
      }
      function update() {
        var c = Math.min(current(), pageCount() - 1);
        Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
          d.setAttribute('aria-current', i === c ? 'true' : 'false');
        });
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize() }); });
      next.addEventListener('click', function () { track.scrollBy({ left: stepSize() }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', buildDots);
      buildDots();
    }
    function initAll() { document.querySelectorAll('[data-lh-carousel]').forEach(initCarousel); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
